import React from 'react';
import { useHistory } from 'react-router-dom';
import PropTypes from 'prop-types';
import { useDispatch, useSelector } from 'react-redux';
import { setEtapeActive } from 'store/etapes/etapesActions';
import { reinitialiseAPI, postAPI } from 'store/apiReducer';
import usagerClientReducer from 'store/usagerReducer';
import {
    API_CREER_TITRE_DETENTION_URL,
    CONTEXT_CREER_TITRE_DETENTION,
} from 'constants/apiUrls.constants';
import RoutesMesDemarches from '../../routes';
import TitreDetentionForm from './form/TitreDetentionForm';
import { getPath } from '../../../../../utils/router';

const CreerTitreDetentionEtape2 = ({ type, defaultValues }) => {
    const history = useHistory();
    const dispatch = useDispatch();

    // Store de creation
    const {
        isLoading: isLoadingCreation,
        data: titreDetention,
        erreur: erreurCreation,
    } = useSelector((state) => state.titreDetention.creer);

    // Enregistrer les données
    const enregistrer = (data) => {
        // Envoyer les donnes pour enregistrement
        dispatch(
            postAPI(
                usagerClientReducer,
                API_CREER_TITRE_DETENTION_URL.replace(':type', type),
                data,
                CONTEXT_CREER_TITRE_DETENTION,
            ),
        );
    };

    // redirigé ver la page mes démarches
    if (isLoadingCreation === false && erreurCreation === false && titreDetention) {
        // initilaiser l'etapes & le store creer titre de detention
        dispatch(setEtapeActive(1));
        dispatch(reinitialiseAPI(CONTEXT_CREER_TITRE_DETENTION));
        // Redirection
        history.push(getPath(RoutesMesDemarches));
    }

    return (
        <>
            <TitreDetentionForm
                type={type}
                defaultValues={defaultValues}
                enregistrer={enregistrer}
                loading={isLoadingCreation}
            />
        </>
    );
};

CreerTitreDetentionEtape2.propTypes = {
    type: PropTypes.string.isRequired,
    defaultValues: PropTypes.object.isRequired,
};

export default CreerTitreDetentionEtape2;
